const AgentIncidentAgGridHook = {
  mounted() {
    const gridContainer = this.el;
    const rows = JSON.parse(gridContainer.dataset.rows || '[]');
    const rowClickEvent = gridContainer.dataset.rowClickEvent;

    const severityColor = value => {
      switch ((value || '').toLowerCase()) {
        case 'high': return 'red';
        case 'medium': return 'orange';
        default: return 'gray';
      }
    };

    const statusColor = value => (value === 'open' ? 'red' : 'green');

    // Keep in sync with PlatformWeb.AgentDisplay.agent_name/1 — JS can't share the Elixir module.
    const agentNames = { A1: 'A1 (Fleet Health)', A2: 'A2 (Config Compliance)', A3: 'A3 (Rollout)', A8: 'A8 (Infrastructure)', A4: 'A4 (Settlement Ops)', A5: 'A5 (Risk Triage)' };
    const agentName = value => agentNames[value] || value;

    const cols = [
      { headerName: 'ID', field: 'id', width: 90, cellStyle: { fontWeight: '600', color: '#374151' } },
      {
        headerName: 'Severity',
        field: 'severity',
        width: 110,
        cellRenderer: params =>
          `<span style="color:${severityColor(params.value)};font-weight:bold;">${params.value || ''}</span>`
      },
      { headerName: 'Domain', field: 'domain', width: 110 },
      { headerName: 'Subject', field: 'subject_ref', flex: 1 },
      {
        headerName: 'Status',
        field: 'status',
        width: 120,
        cellRenderer: params =>
          `<span style="color:${statusColor(params.value)};font-weight:bold;">${params.value || ''}</span>`
      },
      { headerName: 'Owning Agent', field: 'owning_agent', width: 170, valueFormatter: params => agentName(params.value) },
      {
        headerName: 'Correlated',
        field: 'correlated_incident_id',
        width: 130,
        valueFormatter: params => (params.value ? `→ #${params.value}` : ''),
        cellStyle: params => (params.value ? { color: '#2563eb', cursor: 'pointer', textDecoration: 'underline' } : { color: '#2563eb' })
      },
      { headerName: 'Opened', field: 'opened_at', width: 180 }
    ];

    const gridOptions = {
      columnDefs: cols,
      rowData: rows,
      // Clicking the "Correlated" cell jumps straight to that primary incident's own
      // detail (by its id) instead of opening the current row — otherwise "→ #485" is
      // just unclickable text and the user has no way to actually find row #485.
      onCellClicked: event => {
        if (!rowClickEvent) return;
        if (event.colDef.field === 'correlated_incident_id' && event.value) {
          this.pushEvent(rowClickEvent, { id: event.value });
        } else {
          this.pushEvent(rowClickEvent, { id: event.data.id });
        }
      },
      domLayout: 'autoHeight',
      defaultColDef: { resizable: true, sortable: true, filter: true },
      animateRows: true,
      pagination: true,
      paginationPageSize: 20,
      paginationPageSizeSelector: [10, 20, 50, 100]
    };

    if (window.agGrid && window.agGrid.createGrid) {
      this.gridApi = window.agGrid.createGrid(gridContainer, gridOptions);
    } else {
      console.error('AG Grid not available. window.agGrid:', window.agGrid);
    }

    this.handleEvent('update_incidents_data', payload => {
      if (!payload || !Array.isArray(payload.rows) || !this.gridApi) return;
      this.gridApi.setGridOption('rowData', payload.rows);
    });
  },

  destroyed() {
    if (this.gridApi) this.gridApi.destroy();
  }
};

export default AgentIncidentAgGridHook;
